<template>
    <div class="root" style="position: relative">
        <div style="display: flex; background: #726e79; color: white">
            <div class="view-date-text" style="padding: 0 5px;" v-on:click="viewDateTextClicked">{{ formatDate(ViewDate, "yyyy年 MM月") }}</div>
            <div class="head-button" v-on:click="upDownClicked(-1)" style="margin-left: auto">
                <svg viewBox="0 0 200 200" width="18" height="18">
                    <path fill="#FFFFFF" d="M130,20 L150,40 L90,100 L150,160 L130,180 L50,100 L130,20 Z"/>
                </svg>
            </div>
            <div class="head-button" v-on:click="upDownClicked(1)">
                <svg viewBox="0 0 200 200" width="18" height="18">
                    <path fill="#FFFFFF" d="M70,20 L150,100 L70,180 L50,160 L110,100 L50,40 L70,20 Z"/>>
                </svg>
            </div>
        </div>

        <div style="display: flex;">
            <div style="width: 30px; text-align:center" class="sunday">日</div>
            <div style="width: 30px; text-align:center">月</div>
            <div style="width: 30px; text-align:center">火</div>
            <div style="width: 30px; text-align:center">水</div>
            <div style="width: 30px; text-align:center">木</div>
            <div style="width: 30px; text-align:center">金</div>
            <div style="width: 30px; text-align:center" class="saturday">土</div>
        </div>

        <div style="display: flex; flex-wrap: wrap">
            <div v-for="d in Days" :key="d.idx"
                :class="{ day:true, sunday: (d.day==0), saturday: (d.day==6), other: d.other, selected: d.selected }"
                :disabled="d.disabled"
                v-on:click="dayClicked(d.idx)" >
                {{ d.date }}
            </div>
        </div>

        <div class="selected-label" style="padding-left: 5px;" v-on:click="selectedClicked">
            <span>selected: </span>
            <span>{{ formatDate(SelectedDate, "yyyy/MM/dd") }}</span>
        </div>

        <div v-show="InputPanelVisible" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;
            display: flex; justify-content: center; align-items: center; background: rgba(0,0,0,0.6)">
            <div style="display: grid; grid-template-columns: auto auto auto; gap: 1px 10px">
                <div class="tri-button" @click="triangleClicked('y', 1)">▲</div>
                <div class="tri-button" @click="triangleClicked('m', 1)">▲</div>
                <div></div>
                <input v-model="InputYear" style="width: 80px; font-size: 26px; text-align: center; border:none" type="text" maxlength="4" placeholder="年">
                <input v-model="InputMonth" style="width: 50px; font-size: 26px; text-align: center; border:none;" type="text" maxlength="2" placeholder="月">
                <button style="font-size: 16px; border: none; padding: 0 5px; cursor: pointer" v-on:click="inputOkClicked">OK</button>
                <div class="tri-button" @click="triangleClicked('y', -1)">▼</div>
                <div class="tri-button" @click="triangleClicked('m', -1)">▼</div>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
import Util from "../assets/utility"

export default {
    props: {
        value: {
            type: Date,
            default: null,
        },
        min: {
            type: Date,
            default: null,
        },
        max: {
            type: Date,
            default: null,
        }
    },
    data() {
        return {
            /**
             * @type {{
              value:number,
              date:Date,
              day:number,
              other:boolean,
              selected:boolean,
              disabled:boolean,
              }[]}
             */
            Days: [],
            /** @type {Date} */ 
            ViewDate: null,
            /** @type {Date} */
            SelectedDate: null,
            InputPanelVisible: false,
            InputYear: "",
            InputMonth: "",
        }
    },
    watch: {
        value(newVal){
            if(!newVal) return
            this.setValue(newVal)
        }
    },
    created() {
        var d = new Date()
        if(this.$props.value != null){
            d = this.$props.value
        }
        
        this.SelectedDate = new Date(d.getFullYear(), d.getMonth(), d.getDate())
        this.ViewDate = new Date(d.getFullYear(), d.getMonth(), 1)

        for(let i=0; i<42; i++){
            this.Days.push({ idx: i })
        }
        setDays(d.getFullYear(), d.getMonth(), this)
    },
    methods: {
        upDownClicked : function(add){
            setDays(this.ViewDate.getFullYear(), this.ViewDate.getMonth() + add, this)
        },
        dayClicked : function(index){
            var cell = this.Days[index]
            if(cell.disabled) return
            this.setValue(new Date(cell.value))
        },
        viewDateTextClicked : function(){
            this.InputYear = "" + this.ViewDate.getFullYear()
            this.InputMonth = "" + (this.ViewDate.getMonth()+1)
            this.InputPanelVisible = true
        },
        inputOkClicked : function(){
            let y = Number(this.InputYear)
            let m = Number(this.InputMonth)
            if(isNaN(y) || y < 1970 || 2999 < y ) return
            if(isNaN(m) || m < 1 || 12 < m ) return

            let txt = y + "/" + m + "/1 00:00"
            this.setPage(new Date(txt))
        },
        triangleClicked : function(tar, add){
            if(tar=="y"){
                let y = Number(this.InputYear)
                if(isNaN(y)) return
                y+=add
                y = Math.max(y, 1)
                this.InputYear = `${y}`
            }else if(tar=="m"){
                let m = Number(this.InputMonth)
                if(isNaN(m)) return
                m+=add
                if(m < 1) m += 12
                if(m > 12) m -= 12
                this.InputMonth = `${m}`
            }
        },
        selectedClicked : function(){
            this.setPage(this.SelectedDate)
        },
        setPage : function(d){
            setDays(d.getFullYear(), d.getMonth(), this)
            this.InputPanelVisible = false
        },
        setValue: function(d){
            if(d.getTime() != this.SelectedDate.getTime()){
                this.SelectedDate = new Date(d.getFullYear(), d.getMonth(), d.getDate());
                this.setPage(d)
                this.$emit('input', this.getValue())
            }
        },
        getValue: function(){
            return new Date(this.SelectedDate.getTime())
        },
        formatDate(d, format){
            if(d == null) return ""
            return Util.formatDate(d, format) 
        },
    },
}

function setDays(year, month, obj) {
    obj.ViewDate = new Date(year, month, 1)

    let d = new Date(year, month, 1)
    while(d.getDay() != 0){
        d.setDate(d.getDate()-1)
    }
    for(let i=0; i < obj.Days.length; i++){
        obj.Days[i].value = d.getTime()
        obj.Days[i].date = d.getDate()
        obj.Days[i].day = d.getDay()
        obj.Days[i].other = (d.getMonth() != obj.ViewDate.getMonth())
        obj.Days[i].selected = (d.getTime() == obj.SelectedDate.getTime())
        obj.Days[i].disabled = (obj.max != null && obj.max.getTime() < d.getTime())
                            || (obj.min != null && d.getTime() < obj.min.getTime())
        d.setDate(d.getDate()+1)
    }
}

</script>

<style scoped>
.root{
    width: 210px;
    background: white;
    cursor: default;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
}
.head-button{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    min-height: 25px;
    transition: all 300ms ease;
}
.head-button:hover, .view-date-text:hover{
    background: #d2d1e2;
}
.day{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    min-height: 26px;
    transition: all 300ms ease;
    font-family: Vardana;
    border:  1px solid transparent;
    border-radius: 2px;
}
.selected-label:hover{
    color: rgb(127, 129, 163);
}
.day:hover{
    background: lightgray;
}
.sunday{
    color: crimson;
}
.saturday{
    color: royalblue;
}
.other{
    color: darkgray;
}
.selected{
    border-color:darkgray;
}
.day[disabled]{
    text-decoration: line-through gray;
}
.tri-button{
    text-align: center;
    color: white;
    font-size: 20px;
    cursor: pointer;
}
.tri-button:hover,
.tri-button:active{
    color: lightgray;
}
</style>
